var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'terra-x-background-bar-outer',
    { 'terra-x-background-bar-move': _vm.front } ]},[_c('div',{class:[
      'terra-x-background-bar',
      {
        full: _vm.$store.state.layout !== 'LayoutTerraX',
      } ]})])}
var staticRenderFns = []

export { render, staticRenderFns }